import { render, staticRenderFns } from "./Deductions.vue?vue&type=template&id=d8cec446&scoped=true"
import script from "./Deductions.vue?vue&type=script&lang=js"
export * from "./Deductions.vue?vue&type=script&lang=js"
import style0 from "./Deductions.vue?vue&type=style&index=0&id=d8cec446&prod&scoped=true&lang=css"
import style1 from "./Deductions.vue?vue&type=style&index=1&id=d8cec446&prod&lang=css"
import style2 from "./Deductions.vue?vue&type=style&index=2&id=d8cec446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cec446",
  null
  
)

export default component.exports